import React from 'react';
import { observer } from 'mobx-react'
import RefreshIndicator from 'material-ui/RefreshIndicator';
import doctorsStore from '../stores/doctors';

const style = {
  container: {
    position: 'inherit',
  },
  refresh: {
    display: 'inline-block',
    position: 'absolute',
    marginLeft: '50%',
    marginTop: '180px',
  },
};

const Loading = () => (
  <div style={style.container}>
    <RefreshIndicator
      size={50}
      left={-25}
      top={0}
      status={doctorsStore.loadingStatus}
      style={style.refresh}
    />
  </div>
);

export default observer(Loading)


// WEBPACK FOOTER //
// ./src/components/Loading.js